<template>
  <div>
    <v-alert color="#D3EAFD" light>
      <v-row no-gutters>
        <v-col cols="12" md="8">
          <v-list-item class="px-0">
            <v-list-item-avatar color="white" size="60">
              <v-icon color="blue">mdi-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0 px-1">
              <span class="title">Konfirmasi Pusat</span>
              <div class="">
                Anda diharuskan untuk mengisi Sebaran Satuan Pendidikan KS pada tiap jenjang
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="4">
          <v-list-item class="px-0" v-if="currStep < 6 && $allow('psp-peringkat-verval.save-kuota')">
            <v-list-item-content class="px-1">
              <v-btn
                depressed
                small
                color="blue"
                @click="onEdit"
                :disabled="!$allow('psp-peringkat-verval.save-kuota')"
              >
                <v-icon left dark>mdi-pencil</v-icon>
                Set Sebaran Satuan Pendidikan
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>

      <v-alert
        icon="mdi-alert"
        colored-border
        class="pa-2 my-2 bg-notif"
        color="warning"
        style="border-width: 0 !important;"
        v-if="currStep < 6 && $allow('psp-peringkat-verval.konfirmasi-kuota-dinas')"
      >
        <p class="body-2 mb-0 black--text">
          Jika semua data terkait Sebaran Satuan Pendidikan Kepala Sekolah yang akan diterima pada semua jenjang sudah
          lengkap dan final, silakan Anda melakukan konfirmasi data untuk mengirimkan informasi dan melanjutkan ke tahap
          selanjutnya.
        </p>
        <v-btn
          class="mt-2"
          color="orange"
          small
          style="text-transform: capitalize"
          depressed
          @click="onConfirm"
          :disabled="!$allow('psp-peringkat-verval.konfirmasi-kuota-dinas')"
        >
          <v-icon left dark>
            mdi-send
          </v-icon>
          Konfirmasi Data
        </v-btn>
      </v-alert>
    </v-alert>
    <list-pagu ref="pagu" :is-edit="false" :detail="detail"></list-pagu>
    <popup-pagu v-if="popup" ref="formulir" :detail="detail" @save="onSave"></popup-pagu>
  </div>
</template>

<script>
import ListPagu from '../../components/base/ListPagu';
import PopupPagu from '@views/instansi/peringkat/verval/formulir/PopupPagu';
import { mapActions } from 'vuex';
export default {
  name: 'Kandidat',
  components: { ListPagu, PopupPagu },
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      popup: false,
    };
  },
  computed: {
    currStep() {
      const tahap = this.detail && this.detail.k_tahap_peringkat_psp;
      return tahap;
    },
  },
  methods: {
    ...mapActions('peringkatVerval', ['fetch', 'action']),

    onEdit() {
      this.popup = true;
      this.$nextTick(() => {
        this.$refs.formulir.open();
      });
    },

    onSave(data) {
      const params = {
        jenjangs: data,
      };
      this.action({ id: this.detail.psp_peringkat_id, params, aksi: 'save-kuota' }).then(() => {
        this.$emit('reload');
        this.$success('Set Kuota berhasil disimpan');
        this.$refs.formulir.close();
      });
    },

    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped></style>
